import {Route, BrowserRouter, Routes} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Login from "../auth/ui/login";
import Register from "../auth/ui/register";
import VerifyEmail from "../auth/ui/verify";
import {VerifyHint} from "../auth/ui/verifyHint";

import {RequestPasswordReset} from "../auth/ui/RequestPasswordReset";
import ResetPassword from "../auth/ui/resetPassword";
import {InvitationAction} from "../ui/Organization/customer/InvitationAction";
import {RoleBasedLayout} from "./RoleBasedRouting";

export const Router = () => {

    return <BrowserRouter>
        <Routes>
            {/* Public routes */}
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<VerifyEmail />} />
            <Route path="/verify-hint" element={<VerifyHint />} />
            <Route path="/request-password-reset" element={<RequestPasswordReset />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/invitation-action" element={<InvitationAction />} />

            {/* Private routes */}
            <Route
                path="/*"
                element={
                    <PrivateRoute>
                        {/* RoleBasedLayout decides if user sees AdminLayout or CustomerLayout */}
                        <RoleBasedLayout />
                    </PrivateRoute>
                }
            />
        </Routes>
    </BrowserRouter>
}